__turbopack_context__.v({
  "menuItem": "AppFilter-module__nZzDzG__menuItem",
});
